
  class UpsHoldRequest extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('[data-ups-hold-checkbox]');
      this.locationInput = this.querySelector('[data-ups-hold-location]');
      this.details = this.querySelector('[data-ups-hold-details]');

      if (!(this.checkbox instanceof HTMLInputElement)) return;
      if (!(this.locationInput instanceof HTMLInputElement)) return;

      this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
      this.handleLocationChange = this.handleLocationChange.bind(this);

      this.checkbox.addEventListener('change', this.handleCheckboxChange);
      this.locationInput.addEventListener('change', this.handleLocationChange);

      this.syncDisplay();
    }

    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.handleCheckboxChange);
      this.locationInput?.removeEventListener('change', this.handleLocationChange);
    }

    syncDisplay() {
      const active = this.checkbox?.checked === true;
      if (this.details) this.details.hidden = !active;
      if (this.locationInput) this.locationInput.disabled = !active;
    }

    async updateAttributes() {
      const active = this.checkbox?.checked === true;
      const location = active && this.locationInput ? this.locationInput.value.trim() : '';
      const root = window.Shopify?.routes?.root || '/';

      try {
        await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'UPS HOLD FOR PICKUP': active ? 'REQUESTED' : '',
              'UPS Pickup Location': location
            }
          })
        });
      } catch {
      }
    }

    handleCheckboxChange() {
      this.syncDisplay();
      this.updateAttributes();
    }

    handleLocationChange() {
      this.updateAttributes();
    }
  }

  if (!customElements.get('ups-hold-request')) {
    customElements.define('ups-hold-request', UpsHoldRequest);
  }
